const tw = 2;
const waffle = require('./blocks/waffle');
const plainWeave = require('./blocks/plain-weave');
const checker = require('./blocks/checker');
const gingham = require('./blocks/gingham');
const twill = require('./blocks/twill');
const mosaikCustom = require('./blocks/mosaik-custom');

module.exports = {
  'e0b7ad2c-dd75-421f-zv19-9dde30a2157d': {
    name: 'Tac-Tile Module A',
    border: [
      [0, 0],
      [12, 0],
      [12, 9],
      [0, 9],
      [0, 0],
      [15.8125, 0],    
      [15.8125, 9],
      [12,9],
      [12,0],
      [19.625, 0],    
      [19.625, 9],
      [15.8125,9],
      [15.8125,0],
      [24, 0],    
      [24, 9],
      [19.625,9],
      [19.625,0],    
    ]
  },
  'e0b7ad2c-dd75-421f-zv29-9dde30a2157d': {
    name: 'Tac-Tile Module D',
    border: [
      [0, 0],
      [12, 0],
      [12, 9],
      [0, 9],
    ]
  },
  'e0b7ad2c-dd75-421f-zb19-9dde30a2157d': {
    name: 'Tac-Tile Module B',
    border: [
      [0, 0],
      [12, 0],
      [12, 6],
      [0, 6],
      [0, 0],
      [15.8125, 0],    
      [15.8125, 6],
      [12,6],
      [12,0],
      [19.625, 0],    
      [19.625, 6],
      [15.8125,6],
      [15.8125,0],
      [24, 0],    
      [24, 6],
      [19.625,6],
      [19.625,0],
    ]
  },
  'e0b7ad2c-dd75-421f-zb29-9dde30a2157d': {
    name: 'Tac-Tile Module E',
    border: [
      [0, 0],
      [12, 0],
      [12, 6],
      [0, 6],
    ]
  },

  'e0b7ad2c-dd75-421f-zc29-9dde30a2157d': {
    name: 'Tac-Tile Module F',
    border: [
      [0, 0],
      [12, 0],
      [12, 3],
      [0, 3],    
    ]
  },
  'e0b7ad2c-dd75-421f-zc39-9dde30a2157d': {
    name: 'Tac-Tile Module C',
    border: [
      [0, 0],
      [12, 0],
      [12, 3],
      [0, 3],
      [0, 0],
      [15.8125, 0],    
      [15.8125, 3],
      [12,3],
      [12,0],
      [19.625, 0],    
      [19.625, 3],
      [15.8125,3],
      [15.8125,0],
      [24, 0],    
      [24, 3],
      [19.625,3],
      [19.625,0],    
    ]
  },
  'e0b7ad2c-dd75-421f-a639-9dde30a2157d': {
    name: 'AK 10 Block Triangle 90',
    border: [
      [0, 0],
      [12, 12],
      [0, 12]
    ]
  },

  '840ad52b-d579-4233-ba31-ca81de9f34c6': {
    name: 'AK 10 Block Triangle 60',
    border: [
      [6.875, 0],
      [13.75, 12],
      [0, 12]
    ]
  },

  'c8ff74cd-20a5-46c3-856c-325a910bdb27': {
    name: 'AK 10 Block Hex',
    border: [
      [3.375, 0],
      [10.375, 0],
      [13.75, 6],
      [10.375, 12],
      [3.375, 12],
      [0, 6]
    ]
  },

  '4e2bec82-17b4-426a-91a3-465110a9f053': {
    name: 'AK 10 Block Square',
    border: [
      [0, 0],
      [12, 0],
      [12, 12],
      [0, 12]
    ]
  },

  '43f6902a-d03c-4d36-af81-f38d2e2405c9': {
    name: 'AK 10 Block Rectangle A',
    border: [
      [0, 0],
      [24, 0],
      [24, 8],
      [0, 8]
    ]
  },

  '347dca8d-682a-4782-8974-f86eb4f54265': {
    name: 'AK 10 Block Rectangle B',
    border: [
      [0, 0],
      [12, 0],
      [12, 8],
      [0, 8]
    ]
  },

  'a82c43f6-a855-40c7-82c3-c25f2db5e5ba': {
    name: 'AK 10 Block Diamond',
    border: [
      [6.875, 0],
      [13.75, 12],
      [6.875, 24],
      [0, 12]
    ]
  },

  '6fa2d74f-655b-414b-b282-422b21e544b2': {
    name: 'ARO Block 1',
    border: [
      [6.349, 1.09],
      [7.608, 1.09],
      [13.3275, 11],
      [12.698, 12.09],
      [1.259, 12.09],
      [0.6295, 11]
    ]
  },

  'e8a69811-3dfb-4db2-b9c5-e7f22891ee9b': {
    name: 'ARO Block 2',
    border: [
      [5.343, 2.63],
      [8.383, 2.63],
      [12.206, 9.25],
      [10.686, 11.88],
      [3.04, 11.88],
      [1.52, 9.25]
    ]
  },

  '700039ec-4130-4d93-9212-39c57640f8df': {
    name: 'ARO Block 3',
    border: [
      [2, 0],
      [8.5, 1],
      [18.75, 0],
      [16.75, 3.5],
      [16.75, 8],
      [10.25, 7],
      [0, 8],
      [2, 4.5]
    ]
  },

  '0da46e9a-8c97-4977-9712-57870c8f1f94': {
    name: 'ARO Block 4.1',
    border: [
      [1.5, 0],
      [21.75, 0],
      [20.25, 7.75],
      [0, 7.75]
    ]
  },

  '982a1c91-0a01-4630-b8fd-886b29fabb21': {
    name: 'ARO Block 4.2',
    border: [
      [1.5, 0],
      [16, 0],
      [14.5, 7.75],
      [0, 7.75]
    ]
  },

  '679b38fa-ad4d-4382-b53c-80ab3ba70c0d': {
    name: 'Bottle Block',
    bounds: [9.2, 12.05],
    path: 'M0,10.6c2.8,1.9,6.4,1.9,9.2,0c-1.9-2.8-1.9-6.4,0-9.2C6.4-0.5,2.8-0.5,0,1.4C1.9,4.2,1.9,7.8,0,10.6z'
  },

  '6e1bccce-613a-43ce-9d87-7324b33b6cfa': {
    name: 'Fish Block',
    bounds: [12, 6.427],
    path: 'M5.4,6.2c0.8,0.3,1.8,0.3,2.6,0l0.2-0.1c0.6-0.3,1.6-1,2.2-1.4c0.1-0.1,0.3-0.2,0.4-0.2h0C10.9,4.3,11,4.1,11.2,4c0.2-0.2,0.4-0.3,0.7-0.4C11.9,3.5,12,3.4,12,3.2c0-0.1-0.1-0.3-0.2-0.4c-0.2-0.1-0.5-0.3-0.7-0.4c-0.1-0.1-0.3-0.3-0.4-0.5h0c-0.1-0.1-0.3-0.1-0.4-0.2C9.7,1.3,8.8,0.6,8.2,0.3L8,0.2c-0.8-0.3-1.8-0.3-2.6,0C5.3,0.3,5.1,0.4,5,0.4C4.3,0.9,3.4,1.6,2.8,1.9L2.6,1.9C1.8,2.3,0.8,2.3,0,1.9c0.1,0.2,0.2,0.3,0.3,0.5C0.5,2.6,0.8,2.7,1,2.8c0.1,0.1,0.2,0.2,0.2,0.4c0,0.1-0.1,0.3-0.2,0.4C0.8,3.7,0.6,3.8,0.4,4C0.2,4.1,0.1,4.3,0,4.5c0.8-0.3,1.8-0.3,2.6,0l0.2,0.1C3.4,4.8,4.3,5.6,5,6C5.1,6.1,5.3,6.2,5.4,6.2'
  },

  '3cc1e6b7-16af-4e7d-9063-c9177b8f21a9': {
    name: 'Goblet Block',
    bounds: [5.625, 12],
    path: 'M4.7,12c1.3-1.8,1.3-4.2,0-6c-1.4-1.8-1.4-4.2,0-6H1.1c1.4,1.8,1.4,4.2,0,6s-1.4,4.2,0,6H4.7z'
  },

  '036da44e-0a01-4c91-a15d-2e25a63e916c': {
    name: 'Hourglass Block',
    bounds: [12, 12],
    path: 'M7.6,5.5l4.2-5C12,0.4,12.1,0.2,12.1,0H0c0,0.2,0.1,0.3,0.2,0.5l4.3,5c0.3,0.3,0.3,0.7,0,1l-4.3,5C0.1,11.6,0,11.8,0,12h12.1c0-0.2-0.1-0.3-0.2-0.5l-4.3-5C7.4,6.2,7.4,5.8,7.6,5.5z'
  },

  'deea6070-c7cd-4509-8467-5292853e611b': {
    name: 'Spindle Block',
    bounds: [7, 12],
    path: 'M2.9,0h1.2c0,0.6,0.2,1.2,0.5,1.8c0.2,0.5,0.6,0.9,1,1.2s0.7,0.7,1,1.2C6.8,4.8,7,5.4,7,6S6.8,7.2,6.5,7.8C6.3,8.3,5.9,8.7,5.5,9s-0.8,0.7-1,1.2c-0.2,0.6-0.4,1.2-0.4,1.8H2.9c0-0.6-0.2-1.2-0.4-1.8C2.2,9.7,1.9,9.3,1.4,9C1,8.7,0.7,8.3,0.4,7.8C0.2,7.2,0,6.6,0,6s0.2-1.2,0.4-1.8C0.7,3.7,1,3.3,1.4,3s0.8-0.7,1-1.2C2.7,1.2,2.9,0.6,2.9,0z'
  },

  'd69f96d6-5561-4199-bf23-1c8ccbb29558': {
    name: 'Vase Block',
    bounds: [7.87, 12],
    path: 'M1,0h5.8c-1.4,1.8-1.4,4.2,0,6s1.4,4.2,0,6H1c-1.4-1.8-1.4-4.2,0-6S2.4,1.8,1,0z'
  },

  '994f1c2b-3548-42dd-b792-e5c5e9e42e1d': {
    name: 'Chevron Block A',
    border: [
      [0, 0],
      [12, 12],
      [12, 18],
      [0, 6]
    ]
  },

  'cf6c9e6b-cc44-45c2-8cb0-9504ce69431b': {
    name: 'Chevron Block B',
    border: [
      [0, 12],
      [12, 0],
      [12, 6],
      [0, 18]
    ]
  },

  '0d5ebc31-8892-4471-a6d6-bb13ee6a932d': {
    name: 'Dart Block',
    border: [
      [0, 5],
      [5, 0],
      [10, 5],
      [10, 15],
      [5, 10],
      [0, 15]
    ]
  },

  '854ce8f3-c736-4998-9b35-8d874c0bd420': {
    name: 'Picket Block',
    border: [
      [0, 5.0718],
      [2.9282, 0],
      [5.8564, 5.0718],
      [5.8564, 10.9282],
      [2.9282, 16],
      [0, 10.9282]
    ]
  },

  'c85a3088-adef-4e09-87a4-ad827ce8ea61': {
    name: 'Plus Block',
    border: [
      [0, 4],
      [4, 4],
      [4, 0],
      [8, 0],
      [8, 4],
      [12, 4],
      [12, 8],
      [8, 8],
      [8, 12],
      [4, 12],
      [4, 8],
      [0, 8]
    ]
  },

  '717fae39-bca4-4637-8e18-b203024ff3f2': {
    name: 'Scale Small Block',
    bounds: [2.7601, 2.8543, -2.7601, -2.8543],
    variants: {
      // key is a bit-mask where each bit signifies if corresponding corner is being overlapped
      // corners order is clockwise: top-left, top-right, bottom-right, bottom-left
      '0000': 'M-2.7601,-2.8543 L-1.5564,-2.3813 L-1.5564,-1.6559 L-1.3296,-1.6559 L-1.3296,-2.2921 L0,-1.7696 L1.3296,-2.2921 L1.3296,-1.6559 L1.5564,-1.6559 L1.5564,-2.3813 L2.7601,-2.8543 L2.7601,2.8543 L1.5564,2.3813 L1.5564,1.6559 L1.3296,1.6559 L1.3296,2.2921 L0,1.7696 L-1.3296,2.2921 L-1.3296,1.6559 L-1.5564,1.6559 L-1.5564,2.3813 L-2.7601,2.8543 Z M0,1.7696 L0,-1.7696',
      '0001': 'M-2.7601,-2.8543 L-1.5564,-2.3813 L-1.5564,-1.6559 L-1.3296,-1.6559 L-1.3296,-2.2921 L0,-1.7696 L1.3296,-2.2921 L1.3296,-1.6559 L1.5564,-1.6559 L1.5564,-2.3813 L2.7601,-2.8543 L2.7601,2.8543 L1.5564,2.3813 L1.5564,1.6559 L1.3296,1.6559 L1.3296,2.2921 L0,1.7696 L-1.443,2.3367 L-1.443,0.9751 L-2.7601,1.4927 Z M0,-1.7696 L0,1.7696',
      '0010': 'M-2.7601,-2.8543 L-1.5564,-2.3813 L-1.5564,-1.6559 L-1.3296,-1.6559 L-1.3296,-2.2921 L0,-1.7696 L1.3296,-2.2921 L1.3296,-1.6559 L1.5564,-1.6559 L1.5564,-2.3813 L2.7601,-2.8543 L2.7601,1.4927 L1.443,0.9751 L1.443,2.3367 L0,1.7696 L-1.3296,2.2921 L-1.3296,1.6559 L-1.5564,1.6559 L-1.5564,2.3813 L-2.7601,2.8543 Z M0,-1.7696 L0,1.7696',
      '0011': 'M-2.7601,-2.8543 L-1.5564,-2.3813 L-1.5564,-1.6559 L-1.3296,-1.6559 L-1.3296,-2.2921 L0,-1.7696 L1.3296,-2.2921 L1.3296,-1.6559 L1.5564,-1.6559 L1.5564,-2.3813 L2.7601,-2.8543 L2.7601,1.4927 L1.443,0.9751 L1.443,2.3367 L0,1.7696 L-1.443,2.3367 L-1.443,0.9751 L-2.7601,1.4927 Z M0,-1.7696 L0,1.7696',
      '0100': 'M-2.7601,-2.8543 L-1.5564,-2.3813 L-1.5564,-1.6559 L-1.3296,-1.6559 L-1.3296,-2.2921 L0,-1.7696 L1.443,-2.3367 L1.443,-0.9751 L2.7601,-1.4927 L2.7601,2.8543 L1.5564,2.3813 L1.5564,1.6559 L1.3296,1.6559 L1.3296,2.2921 L0,1.7696 L-1.3296,2.2921 L-1.3296,1.6559 L-1.5564,1.6559 L-1.5564,2.3813 L-2.7601,2.8543 Z M0,-1.7696L0,1.7696',
      '0101': 'M-2.7601,-2.8543 L-1.5564,-2.3813 L-1.5564,-1.6559 L-1.3296,-1.6559 L-1.3296,-2.2919 L0,-1.7694 L1.443,-2.3364 L1.443,-0.9748 L2.7601,-1.4925 L2.7601,2.8543 L1.5564,2.3813 L1.5564,1.6559 L1.3296,1.6559 L1.3296,2.2921 L0,1.7696 L-1.443,2.3364 L-1.443,0.9748 L-2.7601,1.4925 Z M0,-1.7696 L0,1.7696',
      '0110': 'M-2.7601,-2.8543 L-1.5564,-2.3813 L-1.5564,-1.6559 L-1.3296,-1.6559 L-1.3296,-2.2921 L0,-1.7696 L1.443,-2.3367 L1.443,-0.9751 L2.7601,-1.4927 L2.7601,1.4927 L1.443,0.9751 L1.443,2.3367 L0,1.7696 L-1.3296,2.2921 L-1.3296,1.6559 L-1.5564,1.6559 L-1.5564,2.3813 L-2.7601,2.8543 Z M0,-1.7696 L0,1.7696',
      '0111': 'M-2.7601,-2.8543 L-1.5564,-2.3813 L-1.5564,-1.6559 L-1.3296,-1.6559 L-1.3296,-2.2919 L0,-1.7696 L1.443,-2.3364 L1.443,-0.9748 L2.7601,-1.4925 L2.7601,1.4925 L1.443,0.9748 L1.443,2.3364 L0,1.7696 L-1.443,2.3364 L-1.443,0.9748 L-2.7601,1.4925 Z M0,-1.7696 L0,1.7696',
      '1000': 'M-2.7601,-1.4927 L-1.443,-0.9751 L-1.443,-2.3367 L0,-1.7696 L1.3296,-2.2921 L1.3296,-1.6559 L1.5564,-1.6559 L1.5564,-2.3813 L2.7601,-2.8543 L2.7601,2.8543 L1.5564,2.3813 L1.5564,1.6559 L1.3296,1.6559 L1.3296,2.2921 L0,1.7696 L-1.3296,2.2921 L-1.3296,1.6559 L-1.5564,1.6559 L-1.5564,2.3813 L-2.7601,2.8543 Z M0,-1.7696 L0,1.7696',
      '1001': 'M-2.7601,-1.4927 L-1.443,-0.9751 L-1.443,-2.3367 L0,-1.7696 L1.3296,-2.2921 L1.3296,-1.6559 L1.5564,-1.6559 L1.5564,-2.3813 L2.7601,-2.8543 L2.7601,2.8543 L1.5564,2.3813 L1.5564,1.6559 L1.3296,1.6559 L1.3296,2.2921 L0,1.7696 L-1.443,2.3367 L-1.443,0.9751 L-2.7601,1.4927 Z M0,-1.7696 L0,1.7696',
      '1010': 'M-2.7601,-1.4925 L-1.443,-0.9748 L-1.443,-2.3364 L0,-1.7694 L1.3296,-2.2919 L1.3296,-1.6559 L1.5564,-1.6559 L1.5564,-2.3813 L2.7601,-2.8543 L2.7601,1.4925 L1.443,0.9748 L1.443,2.3364 L0,1.7696 L-1.3296,2.2919 L-1.3296,1.6559 L-1.5564,1.6559 L-1.5564,2.3813 L-2.7601,2.8543 Z M0,-1.7696 L0,1.7696',
      '1011': 'M-2.7601,-1.4925 L-1.443,-0.9748 L-1.443,-2.3364 L0,-1.7694 L1.3296,-2.2919 L1.3296,-1.6559 L1.5564,-1.6559 L1.5564,-2.3813 L2.7601,-2.8543 L2.7601,1.4925 L1.443,0.9748 L1.443,2.3364 L0,1.7694 L-1.443,2.3364 L-1.443,0.9748 L-2.7601,1.4925 Z M0,-1.7696 L0,1.7694',
      '1100': 'M-2.7601,-1.4927 L-1.443,-0.9751 L-1.443,-2.3367 L0,-1.7696 L1.443,-2.3367 L1.443,-0.9751 L2.7601,-1.4927 L2.7601,2.8543 L1.5564,2.3813 L1.5564,1.6559 L1.3296,1.6559 L1.3296,2.2921 L0,1.7696 L-1.3296,2.2921 L-1.3296,1.6559 L-1.5564,1.6559 L-1.5564,2.3813 L-2.7601,2.8543 Z M0,-1.7696 L0,1.7696',
      '1101': 'M-2.7601,-1.4925 L-1.443,-0.9748 L-1.443,-2.3364 L0,-1.7694 L1.443,-2.3364 L1.443,-0.9748 L2.7601,-1.4925 L2.7601,2.8543 L1.5564,2.3813 L1.5564,1.6559 L1.3296,1.6559 L1.3296,2.2921 L0,1.7696 L-1.443,2.3364 L-1.443,0.9748 L-2.7601,1.4925 Z M0,-1.7694 L0,1.7696',
      '1110': 'M-2.7601,-1.4925 L-1.443,-0.9748 L-1.443,-2.3364 L0,-1.7694 L1.443,-2.3364 L1.443,-0.9748 L2.7601,-1.4925 L2.7601,1.4925 L1.443,0.9748 L1.443,2.3364 L0,1.7696 L-1.3296,2.2919 L-1.3296,1.6559 L-1.5564,1.6559 L-1.5564,2.3813 L-2.7601,2.8543 Z M0,-1.7696 L0,1.7696',
      '1111': 'M-2.7601,-1.4925 L-1.4430,-0.9748 L-1.4430,-2.3364 L0.0000,-1.7694 L1.4430,-2.3364 L1.4430,-0.9748 L2.7601,-1.4925 L2.7601,1.4925 L1.4430,0.9748 L1.4430,2.3364 L0.0000,1.7694 L-1.4430,2.3364 L-1.4430,0.9748 L-2.7601,1.4925 Z M0,1.7694 L0,-1.7694'
    }
  },

  'c52c3cb4-390b-4cac-9ff3-f601c7439369': {
    name: 'Scale Large Block',
    bounds: [5.5625, 5.7085, -5.5625, -5.7085],
    variants: {
      // see Scale Small Block
      '0000': 'M-5.5625,-5.7087 L-2.9882,-4.7065 L-2.9882,-3.2479 L-2.7382,-3.2479 L-2.7382,-4.6092 L0,-3.5433 L2.7382,-4.6092 L2.7382,-3.2479 L2.9882,-3.2479 L2.9882,-4.7065 L5.5625,-5.7087 L5.5625,5.7087 L2.9882,4.7065 L2.9882,3.2479 L2.7382,3.2479 L2.7382,4.6092 L0,3.5433 L-2.7382,4.6092 L-2.7382,3.2479 L-2.9882,3.2479 L-2.9882,4.7065 L-5.5625,5.7087 Z M0,-3.5433 L0,3.5433',
      '0001': 'M-5.5625,-5.7087 L-2.9882,-4.7065 L-2.9882,-3.2479 L-2.7382,-3.2479 L-2.7382,-4.6092 L0,-3.5433 L2.7382,-4.6092 L2.7382,-3.2479 L2.9882,-3.2479 L2.9882,-4.7065 L5.5625,-5.7087 L5.5625,5.7087 L2.9882,4.7065 L2.9882,3.2479 L2.7382,3.2479 L2.7382,4.6092 L0,3.5433 L-2.8632,4.6579 L-2.8632,1.8379 L-5.5625,2.8887 Z M0,-3.5433 L0,3.5433',
      '0010': 'M-5.5625,-5.7087 L-2.9882,-4.7065 L-2.9882,-3.2479 L-2.7382,-3.2479 L-2.7382,-4.6092 L0,-3.5433 L2.7382,-4.6092 L2.7382,-3.2479 L2.9882,-3.2479 L2.9882,-4.7065 L5.5625,-5.7087 L5.5625,2.8887 L2.8632,1.8379 L2.8632,4.6579 L0,3.5433 L-2.7382,4.6092 L-2.7382,3.2479 L-2.9882,3.2479 L-2.9882,4.7065 L-5.5625,5.7087 Z M0,-3.5433 L0,3.5433',
      '0011': 'M-5.5625,-5.7087 L-2.9882,-4.7065 L-2.9882,-3.2479 L-2.7382,-3.2479 L-2.7382,-4.6092 L0,-3.5433 L2.7382,-4.6092 L2.7382,-3.2479 L2.9882,-3.2479 L2.9882,-4.7065 L5.5625,-5.7087 L5.5625,2.8887 L2.8632,1.8379 L2.8632,4.6579 L0,3.5433 L-2.8632,4.6579 L-2.8632,1.8379 L-5.5625,2.8887 Z M0,-3.5433 L0,3.5433',
      '0100': 'M-5.5625,-5.7087 L-2.9882,-4.7065 L-2.9882,-3.2479 L-2.7382,-3.2479 L-2.7382,-4.6092 L0,-3.5433 L2.8632,-4.6579 L2.8632,-1.8379 L5.5625,-2.8887 L5.5625,5.7087 L2.9882,4.7065 L2.9882,3.2479 L2.7382,3.2479 L2.7382,4.6092 L0,3.5433 L-2.7382,4.6092 L-2.7382,3.2479 L-2.9882,3.2479 L-2.9882,4.7065 L-5.5625,5.7087 Z M0,-3.5433 L0,3.5433',
      '0101': 'M-5.5625,-5.7087 L-2.9882,-4.7065 L-2.9882,-3.2479 L-2.7382,-3.2479 L-2.7382,-4.6092 L0,-3.5433 L2.8632,-4.6579 L2.8632,-1.8379 L5.5625,-2.8887 L5.5625,5.7087 L2.9882,4.7065 L2.9882,3.2479 L2.7382,3.2479 L2.7382,4.6092 L0,3.5433 L-2.8632,4.6579 L-2.8632,1.8379 L-5.5625,2.8887 Z M0,-3.5433 L0,3.5433',
      '0110': 'M-5.5625,-5.7087 L-2.9882,-4.7065 L-2.9882,-3.2479 L-2.7382,-3.2479 L-2.7382,-4.6092 L0,-3.5433 L2.8632,-4.6579 L2.8632,-1.8379 L5.5625,-2.8887 L5.5625,2.8887 L2.8632,1.8379 L2.8632,4.6579 L0,3.5433 L-2.7382,4.6092 L-2.7382,3.2479 L-2.9882,3.2479 L-2.9882,4.7065 L-5.5625,5.7087 Z M0,-3.5433 L0,3.5433',
      '0111': 'M-5.5625,-5.7087 L-2.9882,-4.7065 L-2.9882,-3.2479 L-2.7382,-3.2479 L-2.7382,-4.6092 L0,-3.5433 L2.8632,-4.6579 L2.8632,-1.8379 L5.5625,-2.8887 L5.5625,2.8887 L2.8632,1.8379 L2.8632,4.6579 L0,3.5433 L-2.8632,4.6579 L-2.8632,1.8379 L-5.5625,2.8887 Z M0,-3.5433 L0,3.5433',
      '1000': 'M-5.5625,-2.8887 L-2.8632,-1.8379 L-2.8632,-4.6579 L0,-3.5433 L2.7382,-4.6092 L2.7382,-3.2479 L2.9882,-3.2479 L2.9882,-4.7065 L5.5625,-5.7087 L5.5625,5.7087 L2.9882,4.7065 L2.9882,3.2479 L2.7382,3.2479 L2.7382,4.6092 L0,3.5433 L-2.7382,4.6092 L-2.7382,3.2479 L-2.9882,3.2479 L-2.9882,4.7065 L-5.5625,5.7087 Z M0,-3.5433 L0,3.5433',
      '1001': 'M-5.5625,-2.8887 L-2.8632,-1.8379 L-2.8632,-4.6579 L0,-3.5433 L2.7382,-4.6092 L2.7382,-3.2479 L2.9882,-3.2479 L2.9882,-4.7065 L5.5625,-5.7087 L5.5625,5.7087 L2.9882,4.7065 L2.9882,3.2479 L2.7382,3.2479 L2.7382,4.6092 L0,3.5433 L-2.8632,4.6579 L-2.8632,1.8379 L-5.5625,2.8887 Z M0,-3.5433 L0,3.5433',
      '1010': 'M-5.5625,-2.8887 L-2.8632,-1.8379 L-2.8632,-4.6579 L0,-3.5433 L2.7382,-4.6092 L2.7382,-3.2479 L2.9882,-3.2479 L2.9882,-4.7065 L5.5625,-5.7087 L5.5625,2.8887 L2.8632,1.8379 L2.8632,4.6579 L0,3.5433 L-2.7382,4.6092 L-2.7382,3.2479 L-2.9882,3.2479 L-2.9882,4.7065 L-5.5625,5.7087 Z M0,-3.5433 L0,3.5433',
      '1011': 'M-5.5625,-2.8887 L-2.8632,-1.8379 L-2.8632,-4.6579 L0,-3.5433 L2.7382,-4.6092 L2.7382,-3.2479 L2.9882,-3.2479 L2.9882,-4.7065 L5.5625,-5.7087 L5.5625,2.8887 L2.8632,1.8379 L2.8632,4.6579 L0,3.5433 L-2.8632,4.6579 L-2.8632,1.8379 L-5.5625,2.8887 Z M0,-3.5433 L0,3.5433',
      '1100': 'M-5.5625,-2.8887 L-2.8632,-1.8379 L-2.8632,-4.6579 L0,-3.5433 L2.8632,-4.6579 L2.8632,-1.8379 L5.5625,-2.8887 L5.5625,5.7087 L2.9882,4.7065 L2.9882,3.2479 L2.7382,3.2479 L2.7382,4.6092 L0,3.5433 L-2.7382,4.6092 L-2.7382,3.2479 L-2.9882,3.2479 L-2.9882,4.7065 L-5.5625,5.7087 Z M0,-3.5433 L0,3.5433',
      '1101': 'M-5.5625,-2.8887 L-2.8632,-1.8379 L-2.8632,-4.6579 L0,-3.5433 L2.8632,-4.6579 L2.8632,-1.8379 L5.5625,-2.8887 L5.5625,5.7087 L2.9882,4.7065 L2.9882,3.2479 L2.7382,3.2479 L2.7382,4.6092 L0,3.5433 L-2.8632,4.6579 L-2.8632,1.8379 L-5.5625,2.8887 Z M0,-3.5433 L0,3.5433',
      '1110': 'M-5.5625,-2.8887 L-2.8632,-1.8379 L-2.8632,-4.6579 L0,-3.5433 L2.8632,-4.6579 L2.8632,-1.8379 L5.5625,-2.8887 L5.5625,2.8887 L2.8632,1.8379 L2.8632,4.6579 L0,3.5433 L-2.7382,4.6092 L-2.7382,3.2479 L-2.9882,3.2479 L-2.9882,4.7065 L-5.5625,5.7087 Z M0,-3.5433 L0,3.5433',
      '1111': 'M-5.5625,-2.8887 L-2.8632,-1.8379 L-2.8632,-4.6579 L0,-3.5433 L2.8632,-4.6579 L2.8632,-1.8379 L5.5625,-2.8887 L5.5625,2.8887 L2.8632,1.8379 L2.8632,4.6579 L0,3.5433 L-2.8632,4.6579 L-2.8632,1.8379 L-5.5625,2.8887 Z M0,-3.5433 L0,3.5433'
    }
  },

  '1342419c-78c8-11ee-b962-0242ac120002':  twill['color-1'],
  '7657f05e-78c5-11ee-b962-0242ac120002':  twill['color-2'],
  'b8701284-7751-11ee-b962-0242ac120002':  twill['color-3'],
  '44ff1abc-7750-11ee-b962-0242ac120002':  twill['color-4'],

  'fe8f7de4-99d5-11ee-b9d1-0242ac120002': gingham['color-1'],
  'fe8f7f38-99d5-11ee-b9d1-0242ac120002': gingham['color-2'],
  'fe8f8258-99d5-11ee-b9d1-0242ac120002': gingham['color-3'],

  '5bfd32ea-99ff-11ee-b9d1-0242ac120002': checker['color-1'],
  'a70a230e-99e8-11ee-b9d1-0242ac120002': checker['color-2'],
  'a70a220a-99e8-11ee-b9d1-0242ac120002': checker['color-3'],
  'a70a20f2-99e8-11ee-b9d1-0242ac120002': checker['color-4'],
  'a70a1dfa-99e8-11ee-b9d1-0242ac120002': checker['color-5'],
  'a70a1bac-99e8-11ee-b9d1-0242ac120002': checker['color-6'],

  '5bfd37a4-99ff-11ee-b9d1-0242ac120002': waffle['color-1'],
  '5bfd38c6-99ff-11ee-b9d1-0242ac120002': waffle['color-2'],
  '5bfd39de-99ff-11ee-b9d1-0242ac120002': waffle['color-3'],
  'a2be56a6-9aa3-11ee-b9d1-0242ac120002': waffle['color-4'],

  'a2be5e08-9aa3-11ee-b9d1-0242ac120002': plainWeave['color-1'],
  'a2be5f3e-9aa3-11ee-b9d1-0242ac120002': plainWeave['color-2'],
  '0874ca76-9ac6-11ee-b9d1-0242ac120002': plainWeave['color-3'],
  '0874cd1e-9ac6-11ee-b9d1-0242ac120002': plainWeave['color-4'],
  '0874d1ce-9ac6-11ee-b9d1-0242ac120002': plainWeave['color-5'],
  '0874d304-9ac6-11ee-b9d1-0242ac120002': plainWeave['color-6'],
  'a2be59bc-9aa3-11ee-b9d1-0242ac120002': plainWeave['color-7'],

  'ff70ca03-ff13-47f4-b05c-af6abf506500': mosaikCustom['color-1'],
  'ff70ca03-ff13-47f4-b05c-af6abf506501': mosaikCustom['color-2'],
  'ff70ca03-ff13-47f4-b05c-af6abf506502': mosaikCustom['color-3'],
  'ff70ca03-ff13-47f4-b05c-af6abf506503': mosaikCustom['color-4'],
  'ff70ca03-ff13-47f4-b05c-af6abf506504': mosaikCustom['color-5'],
  'ff70ca03-ff13-47f4-b05c-af6abf506505': mosaikCustom['color-6'],
  'ff70ca03-ff13-47f4-b05c-af6abf506506': mosaikCustom['color-7'],
  'ff70ca03-ff13-47f4-b05c-af6abf506507': mosaikCustom['color-8'],
  'ff70ca03-ff13-47f4-b05c-af6abf506508': mosaikCustom['color-9'],
  'ff70ca03-ff13-47f4-b05c-af6abf506509': mosaikCustom['color-10'],
  'ff70ca03-ff13-47f4-b05c-af6abf506510': mosaikCustom['color-11'],
  'ff70ca03-ff13-47f4-b05c-af6abf506511': mosaikCustom['color-12'],
  'ff70ca03-ff13-47f4-b05c-af6abf506512': mosaikCustom['color-13'],
  'ff70ca03-ff13-47f4-b05c-af6abf506513': mosaikCustom['color-14'],
  'ff70ca03-ff13-47f4-b05c-af6abf506514': mosaikCustom['color-15'],
  'ff70ca03-ff13-47f4-b05c-af6abf506515': mosaikCustom['color-16'],
  'ff70ca03-ff13-47f4-b05c-af6abf506516': mosaikCustom['color-17'],
  'ff70ca03-ff13-47f4-b05c-af6abf506517': mosaikCustom['color-18'],
  'ff70ca03-ff13-47f4-b05c-af6abf506518': mosaikCustom['color-19'],
  'ff70ca03-ff13-47f4-b05c-af6abf506519': mosaikCustom['color-20'],
  'ff70ca03-ff13-47f4-b05c-af6abf506520': mosaikCustom['color-21'],
  'ff70ca03-ff13-47f4-b05c-af6abf506521': mosaikCustom['color-22'],
  'ff70ca03-ff13-47f4-b05c-af6abf506522': mosaikCustom['color-23'],
  'ff70ca03-ff13-47f4-b05c-af6abf506523': mosaikCustom['color-24'],
  'ff70ca03-ff13-47f4-b05c-af6abf506524': mosaikCustom['color-25'],
  'ff70ca03-ff13-47f4-b05c-af6abf506525': mosaikCustom['color-26'],
  'ff70ca03-ff13-47f4-b05c-af6abf506526': mosaikCustom['color-27'],
  'ff70ca03-ff13-47f4-b05c-af6abf506527': mosaikCustom['color-28'],
  'ff70ca03-ff13-47f4-b05c-af6abf506528': mosaikCustom['color-29'],
  'ff70ca03-ff13-47f4-b05c-af6abf506529': mosaikCustom['color-30'],
  'ff70ca03-ff13-47f4-b05c-af6abf506530': mosaikCustom['color-31'],
  'ff70ca03-ff13-47f4-b05c-af6abf506531': mosaikCustom['color-32'],
  'ff70ca03-ff13-47f4-b05c-af6abf506532': mosaikCustom['color-33'],
  'ff70ca03-ff13-47f4-b05c-af6abf506533': mosaikCustom['color-34'],
  'ff70ca03-ff13-47f4-b05c-af6abf506534': mosaikCustom['color-35'],
  'ff70ca03-ff13-47f4-b05c-af6abf506535': mosaikCustom['color-36'],
}


// WEBPACK FOOTER //
// ./src/universal/filzfelt/blocks.js